// @ts-nocheck
import React, { SyntheticEvent, useState } from 'react'
import { notifyError } from '@/components'
import { useUploadFeaturesDocsMutation } from './service'
import { LoadingButton } from '@mui/lab'
import { useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'

const MAX_FILE_SIZE = 40 * 1024 * 1024

const UploadFeaturesDoc = ({ documents }: { documents?: any }) => {
  const { id } = useParams()
  const hasDocuments = documents?.length > 0
  const filesInfo = documents?.map((doc) => ({
    url: doc.url,
    fileName: doc.fileName || doc.name || doc.url.split('/').pop() || 'file',
  }))
  const [loading, setLoading] = useState(false)
  const { register } = useForm()
  const [addIDoc] = useUploadFeaturesDocsMutation()
  const handleAddDoc = async (e: SyntheticEvent) => {
    const { files } = e.target as HTMLInputElement
    if (e.target && files?.length) {
      try {
        // Проверяем размер каждого файла
        const oversizedFiles = Array.from(files).filter(
          (file) => file.size > MAX_FILE_SIZE
        )

        if (oversizedFiles.length > 0) {
          notifyError(
            `Следующие файлы превышают допустимый размер 40МБ: ${oversizedFiles
              .map((file) => file.name)
              .join(', ')}`
          )
          // Очищаем input
          e.target.value = ''
          return
        }

        setLoading(true)
        const formData = new FormData()
        // @ts-ignore
        formData.append('deviceId', id)

        // Добавляем все выбранные файлы в FormData
        Array.from(files).forEach((file) => {
          formData.append('documents', file)
        })

        await addIDoc(formData)
      } catch (e) {
        console.log(e)
        notifyError('Произошла ошибка при загрузке файлов')
      }
      setLoading(false)
    }
  }

  const handleDownloadAll = async () => {
    if (!filesInfo?.length) return

    setLoading(true)
    try {
      const downloadPromises = filesInfo.map(async ({ url, fileName }) => {
        const response = await fetch(url)
        const blob = await response.blob()

        const blobUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = blobUrl
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(blobUrl)
      })

      await Promise.all(downloadPromises)
    } catch (error) {
      console.error('Ошибка при скачивании файлов:', error)
      notifyError('Произошла ошибка при скачивании файлов')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <LoadingButton
        variant={'contained'}
        color='success'
        component='label'
        loading={loading}
      >
        Прикрепить
        <form>
          <input
            id='photosInput'
            type='file'
            hidden
            multiple
            accept='.jpg, .png, .pdf'
            {...register('file', { onChange: handleAddDoc })}
          />
        </form>
      </LoadingButton>
      {Boolean(hasDocuments) && (
        <LoadingButton
          variant='contained'
          color='success'
          onClick={handleDownloadAll}
          loading={loading}
        >
          <span>Скачать Все</span>
        </LoadingButton>
      )}
    </>
  )
}

export default UploadFeaturesDoc
